import { render } from "./editorTemplate.vue?vue&type=template&id=a78244ca"
import script from "./editorTemplate.vue?vue&type=script&lang=js"
export * from "./editorTemplate.vue?vue&type=script&lang=js"

import "./editorTemplate.vue?vue&type=style&index=0&id=a78244ca&lang=scss"
import "./editorTemplate.vue?vue&type=style&index=1&id=a78244ca&lang=scss"

import exportComponent from "C:\\Users\\john doe\\Documents\\Venice\\vnc\\AgendaBuilder\\agenda\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__